/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ReportScheduleCreateRequest {
    getFixupPrototypeFunction() { return ReportScheduleCreateRequest.fixupPrototype; }

    static newInstance(model: Partial<ReportScheduleCreateRequest>): ReportScheduleCreateRequest {
        let obj = Object.assign(new ReportScheduleCreateRequest(), model);
        ReportScheduleCreateRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ReportScheduleCreateRequest>): ReportScheduleCreateRequest {
        if (!model) return null;
        return ReportScheduleCreateRequest.newInstance(<ReportScheduleCreateRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ReportScheduleCreateRequest) {
        if (!obj) return;

        models.ReportScheduleCreateRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ReportScheduleCreateRequest): boolean {
        Object.setPrototypeOf(obj, ReportScheduleCreateRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.start_time === "string") {
            this.start_time = new Date(<string><any>this.start_time);
        }
        if (this.recurrence) {
            models.ReportScheduleRecurrence.fixupPrototype(this.recurrence);
        }
        if (this.parameters) {
            for (let val of this.parameters) {
                models.ReportScheduleParameter.fixupPrototype(val);
            }
        }
    }

    /**
     * Name of the schedule; must be unique among the user's schedules
     */
    name: string;

    /**
     * File format the report is delivered in
     */
    export_format: models.ReportScheduleExportFormat;

    /**
     * Email addresses the report is delivered to
     */
    emails: Array<string>;

    /**
     * Date and time of the first run
     */
    start_time: Date;

    /**
     * When the schedule repeats
     */
    recurrence: models.ReportScheduleRecurrence;

    /**
     * Id of the SSRS report to schedule
     */
    report_id: string;

    /**
     * Report parameter values the report is rendered with
     */
    parameters: Array<models.ReportScheduleParameter>;

}
